import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const userService = {
  getProfile: async (userId) => {
    const response = await axios.get(`${API_BASE_URL}/users/${userId}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  updateProfile: async (userId, profileData) => {
    const response = await axios.put(
      `${API_BASE_URL}/users/${userId}`,
      profileData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  getPreferences: async (userId) => {
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/preferences`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  updatePreferences: async (userId, preferencesData) => {
    const response = await axios.put(
      `${API_BASE_URL}/users/${userId}/preferences`,
      preferencesData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  getDashboard: async (userId) => {
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/dashboard`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
};

export default userService;

